import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';

const Component = ({landings, selectedLanding, onContextMenu}) => {
    const getClassName = (landing) => {
        let className = 'context-menu';
        if (selectedLanding && landing.id === selectedLanding.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSValidateTypes
    return (
        <TableContainer><Table>
            <TableHead><TableRow>
                <TableCell>URL</TableCell>
            </TableRow></TableHead>
            <TableBody>
                {landings.map((landing) => (
                    <TableRow key={landing.id} className={getClassName(landing)}
                              onContextMenu={onContextMenu(landing)}
                    >
                        <TableCell><a href={landing.url} target="_blank">
                            {landing.url}
                        </a></TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table></TableContainer>
    );
};

Component.propTypes = {
    landings: PropTypes.array.isRequired,
    selectedLanding: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
